import { fetchQuery, graphql } from "relay-runtime"
import {
  betterDocExchangeQuery,
  betterDocExchangeQuery$data,
} from "@/modules/admin/better-doc/services/__generated__/betterDocExchangeQuery.graphql"
import { RelayEnvironment } from "@/relay-environment"

const query = graphql`
  query betterDocExchangeQuery($exchangeId: Int!) {
    de_betterDocExchange(exchangeId: $exchangeId) {
      exchange {
        exchangeId
        operation
        actor
        httpMethod
        requestUri
        isTestCase
        hasUnexpectedResponse
        responseStatusCode
        durationMilliseconds
        startedAt
        completedAt
        outcome
        failureKind
        patientId
        progressNoteId
      }
      traceParent
      requestHeaders
      requestContentType
      requestBody
      responseHeaders
      responseContentType
      responseBody
      sessionIds
    }
  }
`

export type BetterDocExchangeDetail = NonNullable<betterDocExchangeQuery$data["de_betterDocExchange"]>

export const fetchBetterDocExchange = (exchangeId: number): Promise<BetterDocExchangeDetail | null> =>
  fetchQuery<betterDocExchangeQuery>(RelayEnvironment, query, { exchangeId }, { fetchPolicy: "network-only" })
    .toPromise()
    .then((response) => response?.de_betterDocExchange ?? null)
